// extracted by mini-css-extract-plugin
export var contact = "contact-module--contact--GH2Ds";